import { render, staticRenderFns } from "./AnnuityRefundRules.vue?vue&type=template&id=7c850567&scoped=true"
import script from "./AnnuityRefundRules.vue?vue&type=script&lang=js"
export * from "./AnnuityRefundRules.vue?vue&type=script&lang=js"
import style0 from "./AnnuityRefundRules.vue?vue&type=style&index=0&id=7c850567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c850567",
  null
  
)

export default component.exports